import { useEffect } from "react";

export const useCookieBanner = () => {
  useEffect(() => {
    const cookieBannerId = "onetrust-banner-sdk";
    const acceptAllButtonId = "onetrust-accept-btn-handler";

    const overrideFocus = () => {
      const cookieBanner = document.getElementById(cookieBannerId);
      const acceptAllButton = document.getElementById(acceptAllButtonId) as HTMLButtonElement;

      if (cookieBanner) {
        cookieBanner.blur(); // Remove focus from the cookie banner
      }

      if (acceptAllButton) {
        acceptAllButton.focus(); // Force focus on the "Accept All" button
      }
    };

    let intervalId: NodeJS.Timeout | null = setInterval(() => {
      const activeElement = document.activeElement;
      const cookieBanner = document.getElementById(cookieBannerId);
      const acceptAllButton = document.getElementById(acceptAllButtonId);

      if (cookieBanner && activeElement === cookieBanner && acceptAllButton) {
        overrideFocus(); // Reapply focus to the "Accept All" button
        if (intervalId) {
          clearInterval(intervalId); // Stop the interval after overriding focus
          intervalId = null; // Prevent further calls to clearInterval
        }
      }
    }, 100); // Check every 100ms

    return () => {
      if (intervalId) {
        clearInterval(intervalId); // Cleanup on component unmount
      }
    };

  }, []);
};